var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9tails-client---Si\\xE8ge-social",
    transform: "translate(-1384.000000, -203.000000)",
    fill: "#37DC58",
    fillRule: "nonzero",
    stroke: "#37DC58",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_green",
    transform: "translate(1390.044134, 209.131567) rotate(-90.000000) translate(-1390.044134, -209.131567) translate(1384.345858, 204.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "6.36983212 7.64396612 10.4469219 3.48945599 11.3965535 4.45692933 5.69826014 10.2631343 0 4.45761695 0.949598375 3.48945599 5.02668815 7.64260113 5.02668815 0 6.36983212 0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowPrimary);
export default __webpack_public_path__ + "static/media/icon_arrow_primary.354ba018080bc6370e150603bd6efd21.svg";
export { ForwardRef as ReactComponent };